const kardz = "https://admin-io-vercel.vercel.app/kardz";
// const kardz = "http://localhost:5000/kardz";

export const kardz_url_list = kardz + "/list";
export const kardz_url_update = kardz + "/update";
export const kardz_url_update_meta = kardz + "/update_meta";
export const kardz_url_new = kardz + "/new";
export const kardz_url_login = kardz + "/login";